import { t } from '@avalara/bat-apps-shared/i18n';
import { SCol, SRow } from '@avalara/skylab-sdk/react';

import Banner from '../../styled/components/single-column-banner';

const ThankYouBanner = () => (
  <Banner orange={true} role='complementary'>
    <SRow className='align-items-center'>
      <SCol span='12' center='' className='pad-bottom-none'>
        <h1 className='text-white text-xxl font-normal' data-ref='returns.thankyou-header'>
          {t('client.headings.thanks-for-purchasing-avalara-returns')}
        </h1>
      </SCol>
    </SRow>
  </Banner>
);
export default ThankYouBanner;
